<div *ngFor="let message of messages">
    <div *ngFor="let attribute of message.attributeValues">
        <div
            *ngIf="availableToShow(message)"
            class="alert d-flex align-items-center"
            [ngClass]="classToUse(attribute)"
            role="alert"
        >
            <cmps-icon
                svgIcon="alert"
                *ngIf="showIcon(attribute)"
            ></cmps-icon>
            {{ attribute.defaultMessageText | translate }}
        </div>
    </div>
</div>
